import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DIVIDEND_INVALIDATION_KEYS } from './dividend-invalidation.const';

export const useDividendDelete = () => {
  const { invalidateQuery } = useInvalidateQueries(...DIVIDEND_INVALIDATION_KEYS);

  const { isPending, mutate: deletePayout } = useAppMutation<unknown, unknown, { id: string }>(
    [QueryKey.DELETE_DIVIDEND_PAYOUT],
    {
      mutationFn: ({ id }) =>
        ApiService.delete({ endpoint: BackendRoute.DIVIDENDS, routePath: [id] }),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return { deletePayout, isPending };
};
